<template>
  <div>
    <div id="page-user-list">
      <div class="vx-card p-6">
        <div class="flex flex-wrap items-center">
          <vs-input class="sm:mr-2 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery"
            @input="updateSearchQuery" placeholder="Search..." />
        </div>

        <!-- <div>{{ $store.state.userManagement.users }}</div> -->
        <ag-grid-vue ref="agGridTable" :components="components" :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs" :defaultColDef="defaultColDef"
          :rowData="$store.state.IdManagement.Ids.map(Id => ({ ...Id, temp: temp }))" rowSelection="multiple"
          colResizeDefault="shift" :animateRows="true" :pagination="true" :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true" :enableRtl="$vs.rtl">
        </ag-grid-vue>
        <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
      </div>

      <vs-prompt color="primary" @accept="handleSubmit" title="Identity Information" :active.sync="showModal">
        <div>
          <div class="con-exemple-prompt" style="display: flex; flex-direction: column;">
            <div>
              <img :src="IdInfo.frontImage" style="max-height:250px; max-width:350px" />
            </div>
            <div class="flex gap-5 mb-2">
              <vs-radio v-model="radios1" vs-value="Approved">Approve</vs-radio>
              <vs-radio v-model="radios1" vs-value="Rejected">Reject</vs-radio>
            </div>
            <div class="flex">
              <vs-textarea v-if="radios1 === 'Rejected'" v-model="reject_reason" />
            </div>

          </div>
        </div>
      </vs-prompt>
      <!-- <div v-for="item in this.$store.state.userManagement.users">
        {{ item.IdStatus }}
      </div>
      <br />
      <div v-for="item in this.$store.state.IdManagement.Ids">
        {{ item.status }}
      </div> -->
    </div>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import moduleIdManagement from '@/store/verification-Management/id-management/moduleIdManagement.js'
import handlingError from '@/handlingError/handlingError.js';

// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import CellRenderSelfies from './cell-renderer/CellRenderSelfies.vue'


export default {
  components: {
    AgGridVue,
    vSelect,

    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    CellRenderSelfies
  },
  data() {
    return {
      reject_reason: '',
      radios1: 'luis',
      textarea: '',
      showModal: false,
      IdInfo: {},
      //     // Filter Options
      //     organFilter: { label: 'All', value: 'all' },
      //     organOptions: [
      //       { label: 'All', value: 'all' },
      //       { label: '7*9', value: '7*9' },
      //       { label: '3*9', value: '3*9' },
      //       { label: '8*2', value: '8*2' },
      //       { label: '5*4', value: '5*4' },
      //       { label: 'A*', value: 'A*' },
      //       { label: 'Net*', value: 'net*' }
      //     ],

      //     departFilter: { label: 'All', value: 'all' },
      //     departOptions: [
      //       { label: 'All', value: 'all' },
      //       { label: '1', value: '1' },
      //       { label: '2', value: '2' },
      //       { label: '3', value: '3' },
      //       { label: '4', value: '4' },
      //       { label: '5', value: '5' },
      //       { label: '6', value: '6' },
      //       { label: '7', value: '7' },
      //       { label: '8', value: '8' },
      //       { label: '9', value: '9' },
      //       { label: '10', value: '10' }
      //     ],

      //     teamFilter: { label: 'All', value: 'all' },
      //     teamOptions: [
      //       { label: 'All', value: 'all' },
      //       { label: '1', value: '1' },
      //       { label: '2', value: '2' },
      //       { label: '3', value: '3' },
      //       { label: '4', value: '4' },
      //       { label: '5', value: '5' },
      //       { label: '6', value: '6' },
      //       { label: '7', value: '7' },
      //       { label: '8', value: '8' },
      //       { label: '9', value: '9' },
      //       { label: '10', value: '10' }
      //     ],

      //     universtyFilter: { label: 'All', value: 'all' },
      //     universtyOptions: [
      //       { label: 'All', value: 'all' },
      //       { label: 'Sales', value: 'sales' },
      //       { label: 'Development', value: 'development' },
      //       { label: 'Management', value: 'management' }
      //     ],

      //     statusFilter: { label: 'All', value: 'all' },
      //     statusOptions: [
      //       { label: 'All', value: 'all' },
      //       { label: 'Approved', value: 'approved' },
      //       { label: 'Pending', value: 'pending' }
      //     ],

      //     roleFilter: { label: 'All', value: 'all' },
      //     roleOptions: [
      //       { label: 'All', value: 'all' },
      //       { label: 'Admin', value: 'admin' },
      //       { label: 'Researcher', value: 'researcher' },
      //       { label: 'Engineer', value: 'engineer' }
      //     ],

      searchQuery: '',

      //     // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'User',
          field: 'user.firstname',
          width: 600,
          cellRendererFramework: 'CellRendererLink',
        },
        {
          headerName: 'Last Online',
          field: 'user.updatedAt',
          width: 450,
        },
        {
          headerName: 'Status',
          field: 'status',
          cellRendererFramework: 'CellRendererStatus',
          width: 300
        },
        {
          headerName: 'Actions',
          field: 'email',
          cellRendererFramework: 'CellRendererActions'
        }
      ],

      //     // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
        CellRenderSelfies
      }
    }
  },
  watch: {
    // organFilter(obj) {
    //   this.setColumnFilter('organization', obj.value)
    // },
    // departFilter(obj) {
    //   this.setColumnFilter('department', obj.value)
    // },
    // teamFilter(obj) {
    //   this.setColumnFilter('team', obj.value)
    // },
    // universtyFilter(obj) {
    //   this.setColumnFilter('universty', obj.value)
    // },
    // statusFilter(obj) {
    //   const val = obj.value === 'all' ? 'all' : obj.value === 'approved' ? 'true' : 'false'
    //   this.setColumnFilter('status', val)
    // },
    // roleFilter(obj) {
    //   this.setColumnFilter('role', obj.value)
    // }
  },
  computed: {
    usersData() {
      let users = this.$store.state.userManagement.users
      for (let i = 0; i < users.length; i++)
        users[i].temp = this.temp
      return users
    },
    IdsData() {
      return this.$store.state.IdManagement.Ids
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    // importData() {
    //   this.$router.push('/engineer/import')
    // },
    // exportData() {
    //   this.$router.push('/engineer/export')
    // },
    handleSubmit() {
      if (this.radios1 == 'Approved') {
        this.confirmApproveRecord();
      } else {
        if (this.reject_reason != '')
          this.confirmRejectRecord();
        else {
          this.showModal = true;
          this.$vs.notify({
            color: "danger",
            title: "Rejcet failed!",
            text: "You must write down reject reason.",
          });
        }
      }
    },
    confirmApproveRecord() {
      this.$store
        .dispatch("IdManagement/approveRecord", this.IdInfo._id)
        .then((res) => {
          this.$router.push({ name: 'Refresh Router' });
        })
        .catch((err) => {
          handlingError.handleError(err);
        });
    },
    confirmRejectRecord() {
      const data = {
        userId: this.IdInfo._id,
        reason: this.reject_reason,
      }
      this.$store
        .dispatch("IdManagement/rejectRecord", data)
        .then((res) => {
          this.$router.push({ name: 'Refresh Router' });
        })
        .catch((err) => {
          handlingError.handleError(err);
        });
    },
    temp(data) {
      this.showModal = !this.showModal;
      this.IdInfo = data;
      this.reject_reason = data.statusComment;
      this.radios1 = data.status;
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.organFilter = this.departFilter = this.teamFilter = this.universtyFilter = this.statusFilter = this.roleFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`
    }
  },
  created() {
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    this.$store.dispatch('userManagement/fetchUserWithId').catch(err => { console.error(err) })
    if (!moduleIdManagement.isRegistered) {
      this.$store.registerModule('IdManagement', moduleIdManagement)
      moduleIdManagement.isRegistered = true
    }
    this.$store.dispatch('IdManagement/fetchIds').catch(err => {
      handlingError.handleError(err);
    })
  },
  beforeCreate() {
    if (!this.$store.state.auth.isUserLoggedIn()) this.$router.push('/login');
    //  User Reward Card
  }
}

</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>